export default "/images/Migalhas.png?9e24adb7b699ddf7d4a0f22daf09e66e";